import axios from 'axios';

const actions = {
    async adminGetMatchStats(context, matchId) {
        const url = `api/v1/match-stats/admin/${matchId}`;
        try {
            const res = await axios.get(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
            );
            return res.data;
        } catch (e) {
            return null;
        }
    },

    async adminUpdateStat(context, { statId, payload }) {
        const url = `api/v1/match-stats/admin/stat/${statId}`;
        const res = await axios.put(
            `${context.rootGetters['settings/getEndpoint']}${url}`,
            payload,
            { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
        );
        return res.data;
    },

    async adminUpdatePlayerStat(context, { matchId, userId, payload }) {
        const url = `api/v1/match-stats/admin/${matchId}/stat/user/${userId}`;
        const res = await axios.put(
            `${context.rootGetters['settings/getEndpoint']}${url}`,
            payload,
            { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
        );
        return res.data;
    },

    async adminUpdateMatchScore(context, { matchId, payload }) {
        const url = `api/v1/match-stats/admin/${matchId}/score`;
        const res = await axios.put(
            `${context.rootGetters['settings/getEndpoint']}${url}`,
            payload,
            { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
        );
        return res.data;
    },

    async adminUpdateMvpVote(context, { matchId, voterId, votedForId }) {
        const url = `api/v1/match-stats/admin/${matchId}/mvp/${voterId}`;
        const res = await axios.put(
            `${context.rootGetters['settings/getEndpoint']}${url}`,
            { voted_for_id: votedForId || null },
            { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
        );
        return res.data;
    },

    async adminOverrideUserStats(context, { userId, sport_master, stats }) {
        const url = `api/v1/match-stats/admin/user/${userId}/override`;
        const res = await axios.put(
            `${context.rootGetters['settings/getEndpoint']}${url}`,
            { sport_master, stats },
            { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
        );
        return res.data;
    },

    async adminGetLeaderboard(context, { sport_master, limit, user_id } = {}) {
        const params = new URLSearchParams();
        if (sport_master) params.append('sport_master', sport_master);
        if (limit) params.append('limit', limit);
        if (user_id) params.append('user_id', user_id);
        const query = params.toString() ? `?${params.toString()}` : '';
        const url = `api/v1/match-stats/admin/leaderboard${query}`;
        const res = await axios.get(
            `${context.rootGetters['settings/getEndpoint']}${url}`,
            { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
        );
        return res.data;
    },

    async adminUpsertUserLeaderboard(context, { userId, payload }) {
        const url = `api/v1/match-stats/admin/leaderboard/user/${userId}`;
        const res = await axios.put(
            `${context.rootGetters['settings/getEndpoint']}${url}`,
            payload,
            { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
        );
        return res.data;
    },

    async adminUpdateLeaderboardRow(context, { entryId, payload }) {
        const url = `api/v1/match-stats/admin/leaderboard/${entryId}`;
        const res = await axios.put(
            `${context.rootGetters['settings/getEndpoint']}${url}`,
            payload,
            { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
        );
        return res.data;
    },

    async adminRebuildLeaderboard(context, sport_master) {
        const url = 'api/v1/match-stats/admin/leaderboard/rebuild';
        const res = await axios.post(
            `${context.rootGetters['settings/getEndpoint']}${url}`,
            { sport_master },
            { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
        );
        return res.data;
    },

    async adminRebuildAllLeaderboards(context) {
        const url = 'api/v1/match-stats/admin/rebuild-all';
        const res = await axios.post(
            `${context.rootGetters['settings/getEndpoint']}${url}`,
            {},
            { headers: { Authorization: `Bearer ${context.rootGetters['user/getUser'].token}` } }
        );
        return res.data;
    },
};

export default {
    namespaced: true,
    actions,
};
